import type { InspectionResult } from './inspectionResultSchema'

export function inspectionLifeValues(
  array: ReadonlyArray<ReadonlyArray<number>>,
  elapsed: number,
  calculation: NonNullable<InspectionResult['calculation']>
): number[][] | undefined {
  if (!Number.isFinite(elapsed) || elapsed < 0) return undefined
  if (!supportsInspectionLifeBasis(calculation.provenance)) return undefined
  const bounds = calculation.provenance.bin_bounds
  let min = Infinity
  let finite = 0
  const values = array.map((row, y) =>
    row.map((value, x) => {
      if (
        bounds &&
        (x < bounds.x_start ||
          x >= bounds.x_end ||
          y < bounds.y_start ||
          y >= bounds.y_end)
      )
        return NaN
      if (!Number.isFinite(value)) return NaN
      const adjusted = Math.max(-10, Math.min(150, value) - elapsed)
      min = Math.min(min, adjusted)
      finite++
      return adjusted
    })
  )
  const expected = calculation.result
  if (
    !Number.isFinite(min) ||
    expected.min_remaining_life_years === null ||
    expected.min_remaining_life_years === undefined ||
    Math.abs(min - expected.min_remaining_life_years) > 0.01 ||
    finite !== expected.bins_total
  )
    return undefined
  return values
}

export function supportsInspectionLifeBasis(
  provenance: NonNullable<InspectionResult['calculation']>['provenance']
) {
  return (
    (provenance.minimum_floor_years ?? -10) === -10 &&
    (provenance.upper_limit_years_at_inspection ?? 150) === 150
  )
}
